import ReviewsSnippets from './ReviewsSnippets'

export default ReviewsSnippets
